import React from "react";
import PropTypes from "prop-types";
import { Box, Tab, Tabs } from "@mui/material";

import { clx } from "../../../utils/Helpers";
import "./TabSetsLevels.scss";

const renderTabLabel = (tab) => (
  <span className="tab-sets-levels__label">
    {tab.icon && (
      <span className="tab-sets-levels__icon" aria-hidden="true">
        {tab.icon}
      </span>
    )}
    <span>{tab.label}</span>
  </span>
);

const TabSetsLevels = ({
  tabs,
  value,
  onChange,
  children,
  className,
  size,
  ...props
}) => (
  <Box className={clx("tab-sets-levels", `tab-sets-levels--${size}`, className)}>
    <Tabs
      className="tab-sets-levels__tabs"
      value={value}
      onChange={(_event, nextValue) => onChange?.(nextValue)}
      variant="scrollable"
      scrollButtons={false}
      {...props}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={renderTabLabel(tab)}
          disabled={tab.disabled}
        />
      ))}
    </Tabs>
    {children}
  </Box>
);

TabSetsLevels.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      disabled: PropTypes.bool,
      icon: PropTypes.node,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
};

TabSetsLevels.defaultProps = {
  onChange: undefined,
  children: null,
  className: "",
  size: "md",
};

export default TabSetsLevels;
